import React from "react";
import axios from "axios";

import "./CekgudangCompanies.css";

const emptySummary = {
  total_companies: 0,
  active_companies: 0,
  inactive_companies: 0,
};

const getInitials = name => (name || "Company")
  .split(" ")
  .filter(Boolean)
  .slice(0, 2)
  .map(part => part.charAt(0))
  .join("")
  .toUpperCase();

const formatDate = value => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : new Intl.DateTimeFormat("id-ID", { day: "2-digit", month: "short", year: "numeric" }).format(date);
};

class CekgudangCompanies extends React.Component {
  state = {
    companies: [],
    summary: emptySummary,
    search: "",
    status: "",
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    total: 0,
    loading: true,
    error: "",
  };

  componentDidMount() {
    this.fetchCompanies();
  }

  fetchCompanies = async (page = 1, options = {}) => {
    const search = options.search !== undefined ? options.search : this.state.search;
    const status = options.status !== undefined ? options.status : this.state.status;
    const perPage = options.perPage || this.state.perPage;

    this.setState({ loading: true, error: "" });

    try {
      const response = await axios.get(global.variable.LINK_API + "cekgudang/companies", {
        ...global.variable.HEADERS_BEARER,
        cancelKey: "cekgudang-company-list",
        params: { page, per_page: perPage, search: search.trim(), status },
      });
      this.setState({
        companies: response.data.data || [],
        summary: response.data.summary || emptySummary,
        currentPage: response.data.current_page || 1,
        lastPage: response.data.last_page || 1,
        perPage,
        total: response.data.total || 0,
      });
    } catch (error) {
      this.setState({
        companies: [],
        summary: emptySummary,
        error: error?.response?.data?.message || "Data company SCM 360 belum dapat dimuat.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleFilter = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  applyFilter = event => {
    event.preventDefault();
    this.fetchCompanies(1);
  };

  resetFilter = () => {
    this.setState({ search: "", status: "" }, () => {
      this.fetchCompanies(1, { search: "", status: "" });
    });
  };

  render() {
    const {
      companies, summary, search, status, currentPage, lastPage, perPage, total, loading, error,
    } = this.state;
    const firstRow = total ? (currentPage - 1) * perPage + 1 : 0;
    const lastRow = Math.min(currentPage * perPage, total);

    return (
      <section className="cg-company-page">
        <div className="cg-company-summary">
          <article><span className="cg-company-summary__icon cg-company-summary__icon--blue"><i className="fas fa-building" /></span><div><small>Total company</small><strong>{Number(summary.total_companies).toLocaleString("id-ID")}</strong><p>Terdaftar di SCM 360</p></div></article>
          <article><span className="cg-company-summary__icon cg-company-summary__icon--green"><i className="fas fa-check-circle" /></span><div><small>Company aktif</small><strong>{Number(summary.active_companies).toLocaleString("id-ID")}</strong><p>Dapat menggunakan layanan</p></div></article>
          <article><span className="cg-company-summary__icon cg-company-summary__icon--red"><i className="fas fa-pause-circle" /></span><div><small>Company nonaktif</small><strong>{Number(summary.inactive_companies).toLocaleString("id-ID")}</strong><p>Memerlukan peninjauan</p></div></article>
        </div>

        <article className="cg-company-card">
          <div className="cg-company-card__intro">
            <div><span>SCM 360 DIRECTORY</span><h2>Company terdaftar</h2><p>Daftar organisasi yang terhubung ke ekosistem SCM 360.</p></div>
            <button type="button" onClick={() => this.fetchCompanies(currentPage)} disabled={loading}><i className={`fas fa-sync-alt ${loading ? "fa-spin" : ""}`} /> Perbarui data</button>
          </div>

          <form className="cg-company-filter" onSubmit={this.applyFilter}>
            <div className="cg-company-filter__search"><i className="fas fa-search" /><input type="search" name="search" value={search} onChange={this.handleFilter} placeholder="Cari nama, email, telepon, atau alamat" /></div>
            <select name="status" value={status} onChange={this.handleFilter}><option value="">Semua status</option><option value="1">Aktif</option><option value="0">Nonaktif</option></select>
            <button type="button" className="cg-company-filter__reset" onClick={this.resetFilter}>Reset</button>
            <button type="submit" className="cg-company-filter__submit"><i className="fas fa-filter" /> Terapkan</button>
          </form>

          <div className="cg-company-card__heading">
            <div><strong>Data company</strong><span>{total.toLocaleString("id-ID")} company ditemukan</span></div>
            <label>Tampilkan <select value={perPage} onChange={event => this.fetchCompanies(1, { perPage: Number(event.target.value) })}><option value={10}>10</option><option value={25}>25</option><option value={50}>50</option><option value={100}>100</option></select> baris</label>
          </div>

          {error ? (
            <div className="cg-company-state cg-company-state--error"><span><i className="fas fa-database" /></span><h3>Data belum tersedia</h3><p>{error}</p><button type="button" onClick={() => this.fetchCompanies(currentPage)}>Coba lagi</button></div>
          ) : loading ? (
            <div className="cg-company-state"><span className="cg-company-loader" /><h3>Memuat daftar company</h3><p>Mengambil data terbaru dari SCM 360.</p></div>
          ) : companies.length ? (
            <div className="cg-company-table-wrap">
              <table className="cg-company-table">
                <thead><tr><th>Company</th><th>Kontak</th><th>Kategori</th><th>PPN</th><th>Masa produk</th><th>Status</th></tr></thead>
                <tbody>{companies.map(company => {
                  const active = String(company.is_active) === "1";
                  return <tr key={company.id}>
                    <td><div className="cg-company-identity"><span>{getInitials(company.name)}</span><div><strong>{company.name}</strong><small>ID #{company.id} · Terdaftar {formatDate(company.created_at)}</small></div></div></td>
                    <td><strong>{company.email || "-"}</strong><small>{company.phone || "Telepon belum tersedia"}</small><small>{company.address || "Alamat belum tersedia"}</small></td>
                    <td><strong>Tipe {company.type || "-"}</strong><small>Kategori #{company.category_companies_id || "-"}</small></td>
                    <td><span className={`cg-company-tax ${String(company.is_ppn) === "1" ? "cg-company-tax--active" : ""}`}>{String(company.is_ppn) === "1" ? `PPN ${company.ppn_value || 0}%` : "Non-PPN"}</span></td>
                    <td><strong>{formatDate(company.product_active)}</strong><small>s.d. {formatDate(company.product_expired)}</small></td>
                    <td><span className={`cg-company-status cg-company-status--${active ? "active" : "inactive"}`}><i />{active ? "Aktif" : "Nonaktif"}</span></td>
                  </tr>;
                })}</tbody>
              </table>
            </div>
          ) : <div className="cg-company-state"><span><i className="fas fa-building" /></span><h3>Company tidak ditemukan</h3><p>Ubah kata pencarian atau filter status yang digunakan.</p></div>}

          {!error && !loading && total > 0 && <div className="cg-company-pagination"><span>Menampilkan {firstRow}-{lastRow} dari {total.toLocaleString("id-ID")}</span><div><button type="button" onClick={() => this.fetchCompanies(currentPage - 1)} disabled={currentPage <= 1}><i className="fas fa-chevron-left" /> Sebelumnya</button><strong>Halaman {currentPage} / {lastPage}</strong><button type="button" onClick={() => this.fetchCompanies(currentPage + 1)} disabled={currentPage >= lastPage}>Berikutnya <i className="fas fa-chevron-right" /></button></div></div>}
        </article>
      </section>
    );
  }
}

export default CekgudangCompanies;
